

exports.__esModule = true;
exports.$xoGenericErrorPageComponent = undefined;

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('components/xo-models/src/checkout/index');

require('components/xo-ui-components/src/generic-error/directive');

require('components/xo-return-to-merchant/dist/util');

require('components/xo-ui-components/src/message/directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoGenericErrorPageComponent = exports.$xoGenericErrorPageComponent = _squid.$Component.extend('$xoGenericErrorPageComponent', {
    tag: 'xo-generic-error-page',
    template: _template2['default'],

    controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
    $stateParams, $state, $logger, $CheckoutAppDataModel, $util, $ReturnToMerchant, $q, $populate) {

        $scope.token = $rootScope.token;

        var cancelBlockStateChange = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            $logger.info('state_change_from_generic_error_blocked');
            event.preventDefault();
        });

        $scope.$on('$destroy', cancelBlockStateChange);
    }
});

angular.value("$xoGenericErrorPageComponent", $xoGenericErrorPageComponent);
_squid.$Component;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-generic-error/directive.js
 ** module id = 209
 ** module chunks = 1
 **/